const SEARCH_MODELS = {
  user: 0,
  person: 1,
  competition: 2,
  userRole: 3,
};

export default SEARCH_MODELS;
